// src/utils/auth-helpers.js
import { auth } from '../firebase/firebaseConfig';

export const getAuthHeaders = async () => {
  try {
    const user = auth.currentUser;
    if (!user) {
      console.warn('No authenticated user found');
      throw new Error('User not authenticated');
    }
    
    const idToken = await user.getIdToken();
    
    return {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json',
      'X-Firebase-ID': user.uid
    };
  } catch (error) {
    console.error('Error getting auth headers:', error);
    throw error;
  }
};

export const getFirebaseIdToken = async () => {
  const user = auth.currentUser;
  if (!user) {
    return null;
  }
  try {
    return await user.getIdToken();
  } catch (error) {
    console.error('Error getting ID token:', error);
    return null;
  }
};

export const getCurrentUserId = () => {
  return auth.currentUser?.uid || null;
};

// utils/api-helpers.js

// Define the API base URL
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// // Your existing callLLMProxy function
// export const callLLMProxy = async (provider, data) => {
//   try {
//     const headers = await getAuthHeaders();
    
//     // Ensure temperature is a valid float between 0 and 1
//     if (data.temperature !== undefined) {
//       const temp = parseFloat(data.temperature) || 0.3;
//       data.temperature = Math.min(1.0, Math.max(0.0, temp));
//       console.log(`📤 Sending temperature: ${data.temperature} to ${provider}`);
//     }
    
//     let endpoint;
//     switch (provider.toLowerCase()) {
//       case 'deepseek':
//         endpoint = '/api/llm/deepseek';
//         break;
//       case 'google gemini':
//       case 'gemini':
//         endpoint = '/api/llm/gemini';
//         break;
//       case 'anthropic':
//       case 'claude':
//         endpoint = '/api/llm/claude';
//         break;
//       default:
//         throw new Error(`Unknown provider: ${provider}`);
//     }
    
//     console.log(`🚀 Calling ${provider} at ${endpoint}`);
    
//     // Add abort controller for timeout handling
//     const controller = new AbortController();
//     const timeoutId = setTimeout(() => {
//       console.log('⏱️ Request timeout - aborting...');
//       controller.abort();
//     }, 180000); // 3 minutes timeout
    
//     const response = await fetch(`${API_BASE_URL}${endpoint}`, {
//       method: 'POST',
//       headers,
//       body: JSON.stringify(data),
//       signal: controller.signal
//     });
    
//     clearTimeout(timeoutId);
    
//     if (!response.ok) {
//       const error = await response.json();
//       console.error(`❌ LLM API error:`, error);
      
//       // Provide more specific error messages
//       if (response.status === 504) {
//         throw new Error('Request timeout - the AI is taking too long. Try with a shorter prompt.');
//       } else if (response.status === 429) {
//         throw new Error('Rate limit exceeded. Please wait a moment and try again.');
//       } else if (response.status === 503) {
//         throw new Error(`${provider} service is not available. Please try another provider.`);
//       } else {
//         throw new Error(error.error || error.message || 'LLM API call failed');
//       }
//     }
    
//     const result = await response.json();
//     console.log(`✅ ${provider} response received`);
//     return result;
    
//   } catch (error) {
//     if (error.name === 'AbortError') {
//       console.error('⏱️ Request aborted due to timeout');
//       throw new Error('Request timeout - the AI is taking too long to respond. Please try again with a shorter prompt.');
//     }
//     console.error(`❌ Error calling ${provider}:`, error);
//     throw error;
//   }
// };